exports.genderRadioOptions = [
    'male',
    'female',
    'nonbinary',
    'decline'
];

exports.pronounRadioOptions = [
    {
        value: 'male',
        label: 'He/him'
    },
    {
        value: 'female',
        label: 'She/her'
    },
    {
        value: 'nonbinary',
        label: 'They/them'
    },
    {
        value: 'decline',
        label: 'Skip'
    }
];

exports.ethnicityRadioOptions = [
    'american-indian-or-alaska-native',
    'asian',
    'black',
    'canadian-aboriginal',
    'hispanic-or-latinx',
    'middle-eastern',
    'pacific-islander',
    'white',
    'skip'
];
